<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.push('/main')" />

                <div class="payment-succes-container">
                    <img src="@/assets/icons/specials/bear-cash.svg" alt="">

                    <div>
                        Дякуємо за користування!
                    </div>

                    <div v-if="store.autoWriteOffInternet != '1'" style="color: #E0C522; font-size: 12px; margin-top: 40px; max-width: 480px;">
                        {{ $t('paymentSuccessPage.alertAboutAutoWriteOff') }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { useMainStore } from '@/store/mainStore';

export default {
    name: "PaymentSuccess",

    setup() {
        const store = useMainStore();

        return {
            store
        }
    },
}
</script>
<style lang="scss">
    .payment-succes-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: sans-serif;
        color: #FFF;
        margin-top: 20px;
        padding: 0 20px;
        width: 100%;

        position: absolute;
        top: 20%;
        left: 50%;
        transform: translate(-50%, -20%);

        & > img {
            width: 130px;
            margin-bottom: 20px;
        }

        & > div {
            text-align: center;
            margin-bottom: 20px;
        }

    }
</style>
